<template>
  <transition name="scale-vertically">
    <div v-if="isOpen"
         v-on-click-outside="hide"
         class="UpgradeDropdown__info"
         :class="{'pro': subscription.active}">
      <div class="UpgradeDropdown__info-header">
        <i class="icon-ic_star UpgradeDropdown__info-icon"></i>
      </div>
      <div class="UpgradeDropdown__info-body">
        <div v-if="!subscription.active"
             class="UpgradeDropdown__info-message">
          <div class="UpgradeDropdown__info-title">
            Upgrade to PRO
          </div>
          <div class="UpgradeDropdown__info-text">
            Enjoy up to 100 Participants in a meeting for just $20/month.
            You need to download the app to upgrade to PRO.
          </div>

          <div class="UpgradeDropdown__info-links">
            <a class="UpgradeDropdown__info-link"
               target="_blank"
               href="https://itunes.apple.com/app/kingsconference/id1215191816?mt=8">
              go to appstore
            </a>
            <a class="UpgradeDropdown__info-link"
               target="_blank"
               href="https://play.google.com/store/apps/details?id=com.newmedia.conference&hl=en">
              go to playstore
            </a>
          </div>
        </div>
        <div v-if="subscription.active"
             class="UpgradeDropdown__info-pro-message">
          <div class="UpgradeDropdown__info-title">
            You're now a PRO User
          </div>
          <div class="UpgradeDropdown__info-text">
            Congratulations! You can now have meetings with up to 100 participants.
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  export default {
    name: 'UpgradeDropdown',
    props: {
      isOpen: {
        required: true
      }
    },
    computed: {
      subscription() {
        return this.$store.getters.subscription;
      }
    },
    methods: {
      hide() {
        this.$emit('update:isOpen', false);
      }
    }
  };
</script>

<style scoped lang="scss">
  @import 'style.scss';
</style>



// WEBPACK FOOTER //
// upgrade-dropdown.vue?499edba6